/**
 * assessmentConfig.js
 *
 * Single source of truth for wizard-wide constants. Both BasicInfoStep and
 * GoalStep (and every future step) should import TOTAL_STEPS from here
 * rather than hardcoding it, so the step count never drifts out of sync
 * across files.
 */

export const TOTAL_STEPS = 13;

export const STEP_NUMBERS = {
  WELCOME: 1,
  BASIC_INFO: 2,
  GOAL: 3,
  LIFESTYLE: 4,
  ACTIVITY: 5,
  MEDICAL: 6,
  FOOD_PREFERENCES: 7,
  LIKES: 8,
  DISLIKES: 9,
  MEAL_SCHEDULE: 10,
  WOMENS_HEALTH: 11, // Screen 11 — only rendered when gender === "female"
  SUMMARY: 12,
};